import {IRoutesProvider, RoutesType} from 'Shared/Routes';
import { GeneralRedirect } from 'Shared/Routes';
import { loginRoutes } from 'Shared/routes/LoginRoutes';
import { lazy } from 'solid-js';


export class ArtistRoutes implements IRoutesProvider
{
	routes()
	{
		return ({
			/* Venues point to this to login too */
			'/login':		lazy(() => import('Shared/users/LoginPage')),

			'/': 			() => <GeneralRedirect url='/manager'/>,

			'/manager':		lazy(() => import('Shared/artists/ManagerPage')),
			'/profile/:id':	lazy(() => import('Shared/artists/ProfilePage')),
			'/user':		lazy(() => import('Shared/users/UserPage')),

//TODO share these links between venues and artists (eg common parent)			
		
			...loginRoutes()

//			'/*':	FrontendPageNotFound
		}) as RoutesType;
	}

//TODO maybe trim trailing / from all...
}

